// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G6gF","col":"styles_col__1fEDX"};